import type { ReaderSettings as ReaderSettingsType } from "@/utils/storage";

interface ReaderSettingsProps {
  settings: ReaderSettingsType;
  onChange: (settings: ReaderSettingsType) => void;
}

const fontSizes: { id: ReaderSettingsType["fontSize"]; label: string }[] = [
  { id: "sm", label: "小" },
  { id: "base", label: "中" },
  { id: "lg", label: "大" },
];

const themes: { id: ReaderSettingsType["theme"]; label: string; dot: string }[] = [
  { id: "light", label: "白底", dot: "bg-white border border-background-300" },
  { id: "dark", label: "黑底", dot: "bg-foreground-950" },
  { id: "green", label: "护眼绿", dot: "bg-secondary-200" },
];

export default function ReaderSettings({ settings, onChange }: ReaderSettingsProps) {
  return (
    <div className="absolute right-0 top-12 z-50 w-64 p-4 rounded-lg bg-background-50 border border-background-200 shadow-sm">
      <div className="mb-4">
        <p className="text-xs font-medium text-foreground-500 mb-2">文字大小</p>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100">
          {fontSizes.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onChange({ ...settings, fontSize: item.id })}
              className={`flex-1 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer ${
                settings.fontSize === item.id
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs font-medium text-foreground-500 mb-2">背景阅读模式</p>
        <div className="flex flex-col gap-2">
          {themes.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onChange({ ...settings, theme: item.id })}
              className={`flex items-center gap-3 px-3 py-2 rounded-md text-xs font-medium transition-colors cursor-pointer ${
                settings.theme === item.id
                  ? "bg-accent-100 text-accent-800"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              <span className={`w-4 h-4 rounded-full ${item.dot}`}></span>
              {item.label}
              {settings.theme === item.id && (
                <i className="ri-check-line ml-auto text-base"></i>
              )}
            </button>
          ))}
        </div>
      </div>

      <p className="mt-4 text-[11px] text-foreground-400 leading-relaxed">
        阅读设置会自动保存在本地，下次打开依然生效。
      </p>
    </div>
  );
}